    // EditCustomerForm.js

    import React, { useState, useEffect } from "react";
    import MoreFields from "./MoreFields";

    const EditServiceForm = ({ data, onSubmit, recordId }) => {
    const [customFields, setCustomFields] = useState({});
    const [values, setValues] = useState({
        charges: data.charges,
        service: data.service,
    });

    useEffect(() => {
        setValues({
            service: data.service,
            charges: data.charges,
        });
    }, [data]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log("Changing", name, value);
        setValues((prevValues) => ({
        ...prevValues,
        [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit({ ...values, custom_fields: customFields });
    };

    return (
        <div>
        <form onSubmit={handleSubmit}>
            {/* Render the form fields for editing customer details */}
            <div>
            <label htmlFor="name">Service:</label>
            <input
                type="text"
                name="service"
                value={values.service}
                onChange={handleChange}
            />
            </div>

        
            <div>
            <label htmlFor="contact">Charges:</label>
            <input
                type="number"
                name="charges"
                value={values.charges}
                onChange={handleChange}
            />
            </div>

            <MoreFields
                module="services"
                recordId={recordId}
                values={customFields}
                onChange={setCustomFields}
            />

            <button type="submit" className="button w-full mt-5">Proceed</button>
        </form>
        </div>
    );
    };

    export default EditServiceForm;
